import React, { forwardRef } from "react";
import { InputProps as MuiInputProps } from "@mui/material/Input";
import { Icon } from "../Icon";
import InputAdornment from "../InputAdornment";
import Text from "../Text";

const Search = forwardRef<
  HTMLInputElement,
  MuiInputProps & { ref?: React.Ref<HTMLInputElement> }
>(({ disabled, value, ...props }, ref) => {
  return (
    <Text
      ref={ref}
      value={value}
      disabled={disabled}
      startAdornment={
        <InputAdornment
          value={String(value)}
          disabled={disabled}
          position="start"
        >
          <Icon size="medium" name="search" />
        </InputAdornment>
      }
      role="searchbox"
      {...props}
    />
  );
});

export default Search;
